'use client'

import type { ButtonHTMLAttributes, ElementType, ReactNode } from 'react'
import { createElement } from 'react'
import { cx } from './utils/cx'
import type { AccentVar } from './AccentContext'

export type ButtonVariant = 'default' | 'primary' | 'mono' | 'ink' | 'ghost' | 'danger'
export type ButtonSize = 'lg' | 'xl'
export type ButtonArrow = 'right' | 'left' | 'up' | 'down'

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  variant?: ButtonVariant
  size?: ButtonSize
  arrow?: ButtonArrow
  arrowPos?: 'start' | 'end'
  noHover?: boolean
  accent?: AccentVar
  as?: ElementType
  children?: ReactNode
}

export function Button({
  variant = 'default',
  size,
  arrow,
  arrowPos = 'end',
  noHover,
  accent,
  as,
  className,
  style,
  children,
  ...rest
}: ButtonProps) {
  const Tag: ElementType = as || 'button'
  const accentStyle = accent && variant === 'primary' ? { background: `var(${accent})` } : undefined
  const mergedStyle = accentStyle ? { ...accentStyle, ...style } : style
  const arrowEl = arrow ? <span className={cx('st-arrow', 'dir-' + arrow)} aria-hidden="true" /> : null
  return createElement(
    Tag,
    {
      className: cx('st-btn', variant !== 'default' && variant, size, noHover && 'no-hover', className),
      style: mergedStyle,
      ...rest
    },
    arrow && arrowPos === 'start' ? arrowEl : null,
    children,
    arrow && arrowPos === 'end' ? arrowEl : null
  )
}
